import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .registration-page {

    .registration-area {
      padding: 10px 0;
      background: #f8f8f8;

      .registration-box {
        max-width: 1700px;
        margin: auto;
        // border: 1px solid ${colors.bg2};
        // box-shadow: 0 0px 20px rgba(0, 0, 0, 0.08);
        padding: 25px 30px;
        border-radius: 5px;

        .registration-heading {
          h4 {
            color : ${colors.black2};
            text-transform: uppercase;
            font-weight: 600;
            padding-bottom: 10px;
            margin-bottom: 20px;
            position: relative;
            &:before {
                position: absolute;
                content: "";
                background: ${colors.green};
                width: 100px;
                height: 2px;
                bottom: 0;
                left: 50%;
                margin-left: -35px;
            }
  
            @media(max-width: 575px) {
                font-size : 20px;
            }
          }
        }

        .registration-heading h4 {
          color: ${colors.black1};
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 5px;
          font-size: 20px;

          span {
            color: ${colors.green};
          }

          @media (max-width: 575px) {
            margin-bottom: 15px;
            font-size: 18px;
          }
        }

        .box-row {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          margin-top: 50px;

          .selection-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 50px;
            box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
            border-radius: 5px;
            height: 250px;
            background: #fff;
            padding: 20px;
            text-align: center;
            transition: all 0.3s ease;
            cursor: pointer;
            color: #000;

            &:hover {
              // border : 2px solid #1c73c9;
              // border-radius: 5px;
              transform: translateY(-5px);
              background: ${colors.card_hover_blue}; 
              
            }

            .box-heading {
              /* Your styles for box-heading */
            }

            .box-heading h3 {
              color: ${colors.black1};
              font-weight: 600;
            //   text-transform: uppercase;
              font-size: 14px;

              @media (max-width: 575px) {
                font-size: 12px;
              }
            }

            .box-logo {
              
            }

            .box-price {
              /* Your styles for box-price */
            }

            .box-subtitle {
              /* Your styles for box-subtitle */
            }

            .box-subtitle p {
              font-size: 12px;
            }

            .box-subtitle span {
              color: ${colors.green};
              font-size: 14px;
              font-weight: 600;
            }

            .checkmark-icon {
              display: none;
              position: absolute;
              top: 10px;
              right: 10px;
              width: 20px;
              height: 50px;
              background-size: cover;
            }

            // &:hover .checkmark-icon {
            //     display: block !important;
            // }

            .selection-box.selected .checkmark-icon {
                display: block !important; /* Show the checkmark icon when the component is selected */
            }

            .selection-box.selected {
                background: ${colors.card_hover_blue} !important; 
            }
          }
        }

        .box-info-area {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;

          .box-info {
            font-weight: 600;
          }

          .box-info p {
            font-size: 14px;
          }

          .box-info span {
            color: ${colors.green};
          }

          .next-button-col{
            display: flex;
            justify-content: flex-end;
          }
          .next-button{
            height: 50px;
            width: 80px;
            font-size: 18px;
            background-color: ${colors.green};
            border: none;
            border-radius: 5px;
            outline: none !important;  
          }
          .next-button:focus {
            outline: none !important;
            box-shadow: none !important;
          }
        }
        }
      }
    }
`;



export const FormStyles = styled.div`
  .form-group {
    padding      : 0;
    height       : auto;
    background   : transparent;
    border       : none;
    margin-bottom: 28px;
    position     : relative;
  }
  
  .form-label {
    font-size : 15px;
    color : ${colors.text1};
    font-weight : 500;

    @media(max-width: 575px) {
        font-size : 14px;
    }
  }
  
  .form-control {
    width :  100%;
    height          : 48px;
    background-color: #ffffff;
    font-size       : 14px;
    padding         : 15px 20px;
    color           : ${colors.black1};
    border          : 1px solid ${colors.border3};
    border-radius : 5px;

    &::placeholder {
      font-size : 14px;
      font-style: italic;
      color     : ${colors.text3};

      @media(max-width: 575px) {
          font-size : 13px;
      }
    }

    &:disabled {
      background-color: #e1e2e3;
      color: #6c757d;
      border-color: #ced4da;
    }

    &:focus {
      border-color : ${colors.green};
    }

    @media(max-width: 575px) {
      height : 40px;
    }

  }

  .error-message {
    color: #dc3545;
    margin-top: 5px;
    font-size: 10px;
  }

  .select-container {
    width: 100%;

    .select__control {
      height: 48px;
      background-color: #ffffff;
      font-size: 14px;
      color: #000000;
      border: 1px solid #ced4da;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        border-color: #28a745;
        
      }
    }

    .select__menu {
      background-color: #ffffff;
      border: 1px solid #ced4da;
      border-radius: 5px;
      z-index: 9999;

      .select__option {
        padding: 8px 12px;
        cursor: pointer;

        &.select__option--is-selected {
          background-color: #28a745;
          color: #ffffff;
        }

        &:hover {
          background-color: #f8f9fa;
          
        }
      }
    }

    .select__multi-value {
      background-color: #28a745;
      color: #ffffff;
      border-radius: 5px;
      padding: 4px 8px;
      margin: 2px;
      
    }

    .select__multi-value__remove {
      color: #ffffff;
      cursor: pointer;
    }
  }

  .captcha-container {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }

  .captcha-image {
    width: 120px;
    height: 40px;
    margin-right: 10px;
    /* Add any additional styling for the captcha image */
  }

  .refresh-button {
    margin-right: 10px;
    /* Add any additional styling for the refresh button */
  }

  .captcha-input {
    width: 150px;
    height: 36px;
    background-color: #ffffff;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    /* Add any additional styling for the captcha input */
  }

  .otp-container {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }

  .send-otp-button {
    margin-right: 10px;
    /* Add any additional styling for the send OTP button */
  }

  .otp-input {
    width: 150px;
    height: 36px;
    background-color: #ffffff;
    font-size: 14px;
    padding: 5px 10px;
    border: 1px solid #ced4da;
    border-radius: 5px;
    /* Add any additional styling for the OTP input */

    &:disabled {
      background-color: #e1e2e3;
      color: #6c757d;
      border-color: #ced4da;
    }
  }
  
`;
